
<div [class.arebic-content]="textDirection == 'rtl'">

   <h1 class="title" translate> LEARN_MORE_PAGE.BOOST_BUSINESS </h1>
   
   <div class="parent" *ngFor="let item of benefits"  >
      <div class="col-1">
       <img [src]="item.icon" />
      </div>
      <div class="col-11">
       <h2 translate> {{item.value}} </h2>
       <p translate> {{item.desc}} </p>
      </div>
   </div>
</div>